let token: string | null = null

export function csrfToken(): string | null {
  if (token) return token
  if (typeof document === 'undefined') return null
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || null
}

export function syncCsrfToken(next: string | null | undefined) {
  if (!next) return
  token = next
  if (typeof document === 'undefined') return
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
  if (meta) meta.content = next
}
